import React, { FC } from 'react';
import { CustomText } from '../../../@shared/customText';
import Picture from '../../../@shared/picture';
import { TInteractiveImageMblDeskItemFieldItemField } from '../../types/interactiveImage.types';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import CTA, { ctaTypes } from '../../../@shared/cta';

const InteractiveSplitModule: FC<TInteractiveImageMblDeskItemFieldItemField> = (props) => {
  return (
    <div className="interactive-image-split-module">
      <Picture
        editorialImageProps={{
          mobileImage: props.image,
          mobileTransformation: 'Size1000',
          cssClassPictureEl: 'interactive-image-split-module__picture',
          cssClassImageEl: 'interactive-image-split-module__image',
        }}
      />
      <div className="interactive-image-split-module__content">
        {props.title && <CustomText tag={'h3'} field={props.title} className={'interactive-image-split-module__title'} />}
        {props.description && (
          <RichText
            tag="div"
            field={props.description}
            className={'interactive-image-split-module__description rich-text color-primary-link'}
          />
        )}
        <div className="interactive-image-split-module__ctas">
          {props.link1?.value?.text && props.link1?.value?.href && (
            <CTA type={ctaTypes.primaryRed} field={props.link1} extraClassName="interactive-image-split-module__primary-cta" />
          )}
          {props.link2?.value?.text && props.link2?.value?.href && (
            <CTA type={ctaTypes.secondaryRed} field={props.link2} extraClassName="interactive-image-split-module__secondary-cta" />
          )}
        </div>
      </div>
    </div>
  );
};

export default InteractiveSplitModule;
